var map = {
	"./icon1.svg": 8449,
	"./icon10.svg": 5740,
	"./icon11.svg": 9004,
	"./icon12.svg": 9099,
	"./icon13.svg": 1108,
	"./icon14.svg": 1249,
	"./icon15.svg": 2040,
	"./icon16.svg": 4691,
	"./icon17.svg": 8203,
	"./icon18.svg": 1684,
	"./icon19.svg": 6102,
	"./icon2.svg": 6405,
	"./icon20.svg": 9755,
	"./icon21.svg": 1542,
	"./icon22.svg": 3189,
	"./icon3.svg": 5638,
	"./icon4.svg": 7440,
	"./icon5.svg": 1126,
	"./icon6.svg": 1581,
	"./icon7.svg": 5473,
	"./icon8.svg": 3549,
	"./icon9.svg": 2431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;